<template>
    <div>
        <main-header
            ref="mainHeader"
            :language="language"
            :languages="languages"
            :theme="theme"
            :themes="themes"
        />
        <router-view
            @updateHeaderNavigation="updateHeaderNavigation"
            @updateHeaderTabBar="updateHeaderTabBar"
        />
    </div>
</template>

<script>
    import Header from "../components/Header";
    export default {
        name: "Root",
        components: {MainHeader : Header},
        props: {
            language:  String,
            languages: Array,
            theme:     String,
            themes:    Array
        },
        methods: {
            updateHeaderNavigation(headerNavigation) {
                this.$refs.mainHeader.updateHeaderNavigation(headerNavigation);
            },
            updateHeaderTabBar(route, additionalInformation) {
                this.$refs.mainHeader.updateHeaderTabBar(route, additionalInformation);
            }
        }
    }
</script>

<style scoped>

</style>
<style>
    div.coa_snack > div.v-sheet {
        border: 2px solid;
        border-color: var(--sc-blue-dark) !important;
        border-radius: 0;
        width: 75%;
    }
    div.coa_snack > div.v-sheet > div.v-snack__content {
        display: inline-block;
        flex-grow: unset;
        width: auto;
        margin: 0 auto;
        background-image: url("../assets/icons/done.svg");
        background-repeat: no-repeat;
        background-position: left center;
        padding-left: 40px;
    }

    div.coa_snack.coa_error > div.v-sheet {
        border-color: var(--error-red) !important;
    }
    div.coa_snack.coa_error > div.v-sheet > div.v-snack__content {
        background-image: url("../assets/icons/warning.svg");
    }
</style>